<!--  -->
<template>
  <div class="tablwbox">
    <div class="srrwrw">
      <div class="search_box">
        <el-input
          v-model="paquery.title"
          placeholder="请输入标题"
          style="width:200px;"
        />
        <el-input
          v-model="paquery.group_message_no"
          placeholder="请输入群欢迎语编号"
          style="width:200px;"
        />
        <el-input
          v-model="paquery.corp_id"
          placeholder="请输入企业id"
          style="width:200px;"
        />
        <el-select
          v-model="paquery.onlyMe"
          placeholder="请选择组内组外"
        >
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-model="paquery.msg_type"
          placeholder="请选择类型"
        >
          <el-option
            v-for="item in accountarrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="srarch"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="add"
        >新增</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      min-height="900"
      style="width: 100%;"
    >
      <el-table-column
        prop="title"
        label="标题"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column
        prop="group_message_no"
        label="群欢迎语编号"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.group_message_no }}
        </template>
      </el-table-column>
      <el-table-column
        prop="template_id"
        label="模板id"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.template_id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="corp_name"
        label="企业名称(企业id)"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.corp_name }}({{ scope.row.corp_id }})
        </template>
      </el-table-column>
      <el-table-column
        prop="msg_type_str"
        label="类型"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.msg_type_str }}
        </template>
      </el-table-column>
      <el-table-column
        prop="creator"
        label="创建人"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.creator }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="170"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.created_at_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleter(scope.row.id)"
          >删除</el-button>
          <el-button
            type="warning"
            size="mini"
            @click="add2(scope.row)"
          >复用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <template #title>
        企微群欢迎语<span class="red-title">（每个企业最多100个群欢迎语素材）</span>
      </template>
      <welcomeWeChatdialog
        ref="welcomeWeChatdialog"
        @updata="callback"
      />
    </el-dialog>
    <el-dialog
      title="错误信息"
      :visible.sync="errordialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
    >
      <el-table
        :data="errordata"
        border
        style="width: 100%"
        max-height="300"
      >
        <el-table-column
          prop="corp_id"
          label="企业ID"
          width="200"
          align="center"
        />
        <el-table-column
          prop="corp_name"
          label="企业名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="msg"
          label="错误信息"
          align="center"
        />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { groupWelcomeindex, groupWelcomedelete } from '@/api/weChatMerchants.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import welcomeWeChatdialog from './components/welcomeWeChatdialog.vue'
export default {
  name: 'Wechatseting',
  components: {
    PaginationRight,
    welcomeWeChatdialog
  },
  data() {
    return {
      dialogVisible: false,
      paquery: {
        page: 1,
        page_size: 10,
        title: '',
        group_message_no: '',
        corp_id: '',
        onlyMe: 2
      },
      total: null,
      tableData: [],
      qrcode: '',
      loading: false,
      imageData: '',
      assort_name: '',
      accountarr: [
        {
          value: 1,
          label: '查看组内欢迎语'
        },
        {
          value: 2,
          label: '我关联的欢迎语'
        }
      ],
      accountarrr: [
        {
          value: 'text',
          label: '文本'
        },
        {
          value: 'image',
          label: '图片'
        },
        {
          value: 'link',
          label: '图文链接'
        },
        {
          value: 'miniprogram',
          label: '小程序消息'
        }
      ],
      errordata: [],
      errordialog: false
    }
  },
  activated() {
    this.sawrlist()
  },
  created() {
    this.sawrlist()
  },
  mounted() {},
  methods: {
    async sawrlist() {
      this.loading = true
      const data = await groupWelcomeindex(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data.data)
    },
    fetchPageSizeone(e) {
      this.paquery.page_size = e
      this.sawrlist()
    },
    fetchCurrentPageone(e) {
      this.paquery.page = e
      this.sawrlist()
    },
    srarch() {
      this.paquery.page = 1
      this.sawrlist()
    },
    reset() {
      this.paquery.page = 1
      this.paquery.page_size = 10
      this.paquery.msg_type = ''
      this.paquery.title = ''
      this.paquery.group_message_no = ''
      this.paquery.corp_id = ''
      this.paquery.onlyMe = 2
      this.sawrlist()
    },
    add2(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.welcomeWeChatdialog.send(3, item)
      })
    },
    add(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.welcomeWeChatdialog.send(1, item)
      })
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.welcomeWeChatdialog.send(2, item)
      })
    },
    callback(errordata) {
      this.dialogVisible = false
      this.sawrlist()
      console.log('errordata', errordata)
      if (errordata.length !== 0) {
        this.errordata = []
        this.errordata = errordata
        this.errordialog = true
      }
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    deleter(id) {
      console.log('id', id)
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          groupWelcomedelete({
            id: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.sawrlist()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    handleSelect(item) {
      console.log(item)
      this.paquery.assort_id = item.id
      this.assort_name = item.name
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tablwbox {
  padding: 20px;
}
.srrwrw {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.red-title {
  color: #f56c6c;
}
@media (max-width: 768px){
  .cell button{
    margin:1vw 0px;
  }
}
</style>
